// ── Nav scroll effect ──────────────────────────────────────────────────────
window.addEventListener('scroll', () => {
  document.querySelector('nav')?.classList.toggle('scrolled', window.scrollY > 60);
});

// ── Mobile Navigation ──────────────────────────────────────────────────────
function toggleMobileNav() {
  const nav = document.getElementById('mobile-nav');
  const overlay = document.getElementById('mobile-nav-overlay');
  const burger = document.getElementById('hamburger');
  if (!nav) return;
  const isOpen = nav.classList.contains('open');
  nav.classList.toggle('open', !isOpen);
  overlay.classList.toggle('open', !isOpen);
  burger.classList.toggle('open', !isOpen);
  burger.setAttribute('aria-expanded', String(!isOpen));
  document.body.style.overflow = isOpen ? '' : 'hidden';
}
function closeNav() {
  document.getElementById('mobile-nav')?.classList.remove('open');
  document.getElementById('mobile-nav-overlay')?.classList.remove('open');
  document.getElementById('hamburger')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ── Cart Badge ─────────────────────────────────────────────────────────────
function updateCartBadge(count) {
  const badge = document.getElementById('cart-count-badge');
  if (!badge) return;
  if (count > 0) {
    badge.textContent = count;
    badge.style.display = 'inline';
  } else {
    badge.style.display = 'none';
  }
}

// ── Cart Drawer ─────────────────────────────────────────────────────────────
const FREE_SHIPPING_THRESHOLD = 7500; // cents — matches settings

function openCartDrawer() {
  closeNav();
  refreshCartDrawer().then(() => {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.getElementById('cart-drawer-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}

function closeCartDrawer() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-drawer-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// Close on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCartDrawer();
    closeNav();
  }
});

function refreshCartDrawer() {
  return fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const body   = document.getElementById('cart-drawer-body');
      const footer = document.getElementById('cart-drawer-footer');
      const countEl  = document.getElementById('drawer-item-count');
      const subtotalEl = document.getElementById('drawer-subtotal');
      const shippingBarEl = document.getElementById('drawer-shipping-bar');

      // Update nav badge
      updateCartBadge(cart.item_count);

      // Item count label
      if (countEl) {
        countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'ITEM' : 'ITEMS');
      }

      if (cart.item_count === 0) {
        body.innerHTML = `
          <div class="cart-drawer-empty">
            <div class="cart-drawer-empty-icon">🛒</div>
            <div class="cart-drawer-empty-title">YOUR BAG IS EMPTY</div>
            <p class="cart-drawer-empty-sub">Add something beautiful to begin.</p>
            <a href="/collections" class="cart-drawer-empty-cta" style="margin-top:20px;">SHOP NOW →</a>
          </div>`;
        if (footer) footer.style.display = 'none';
        return;
      }

      // Format money
      const fmt = (cents) => new Intl.NumberFormat('en-US', {
        style: 'currency', currency: cart.currency
      }).format(cents / 100);

      // Subtotal
      if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);

      // Free shipping progress bar
      if (shippingBarEl) {
        const threshold = FREE_SHIPPING_THRESHOLD;
        if (cart.total_price < threshold) {
          const remaining = threshold - cart.total_price;
          const pct = Math.min(100, (cart.total_price / threshold) * 100);
          shippingBarEl.innerHTML = `
            <div class="drawer-shipping-bar">
              <p>Add <strong>${fmt(remaining)}</strong> for free shipping</p>
              <div class="drawer-shipping-track">
                <div class="drawer-shipping-fill" style="width:${pct}%"></div>
              </div>
            </div>`;
        } else {
          shippingBarEl.innerHTML = `
            <div class="drawer-shipping-bar">
              <p><strong>✓ You've unlocked free shipping!</strong></p>
            </div>`;
        }
      }

      // Render items
      body.innerHTML = cart.items.map(item => `
        <div class="cart-drawer-item">
          <div class="cart-drawer-img">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
          </div>
          <div class="cart-drawer-info">
            <div>
              <div class="cart-drawer-item-type">${(item.product_type || 'AESTRA').toUpperCase()}</div>
              <div class="cart-drawer-item-name">${item.product_title.toUpperCase()}</div>
              ${item.variant_title && item.variant_title !== 'Default Title'
                ? `<div class="cart-drawer-item-variant">${item.variant_title.toUpperCase()}</div>`
                : ''}
            </div>
            <div class="cart-drawer-item-bottom">
              <div class="cart-drawer-qty">
                <button onclick="drawerUpdateQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button onclick="drawerUpdateQty('${item.key}', ${item.quantity + 1})" aria-label="Increase quantity">+</button>
              </div>
              <div style="display:flex;align-items:center;gap:10px;">
                <span class="cart-drawer-item-price">${fmt(item.final_line_price)}</span>
                <button class="cart-drawer-remove" onclick="drawerRemoveItem('${item.key}')" aria-label="Remove item">✕</button>
              </div>
            </div>
          </div>
        </div>
      `).join('');

      if (footer) footer.style.display = 'block';
    });
}

function drawerUpdateQty(key, qty) {
  if (qty < 0) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(() => refreshCartDrawer());
}

function drawerRemoveItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(() => refreshCartDrawer());
}

// ── Add-to-cart helper (called by product/collection pages) ────────────────
// Fires after any page's addToCart or quickAdd completes
function onAddedToCart() {
  openCartDrawer();
}

// ── Color swatches ─────────────────────────────────────────────────────────
document.querySelectorAll('.product-colors').forEach(row => {
  row.querySelectorAll('.color-dot').forEach(dot => {
    dot.addEventListener('click', () => {
      row.querySelectorAll('.color-dot').forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
    });
  });
});
